import apiRequest from './apiRequest';

const hsnApi = {
    async uploadHsn(data, token) {
        const url = '/api/invoice/hsn';
        return apiRequest(url, 'POST', token, data);
    },
    async searchHsn(code, token) {
        const url = `/api/invoice/hsn/search?code=${code}`;
        return apiRequest(url, 'GET', token);
    },
};

export default hsnApi;


